import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class CopyLeverantorsorderCommand extends BasicCommand<CopyLeverantorsorderCommand> {
    get primaryKey(): IPrimaryKey<CopyLeverantorsorderCommand> {
        return {
            leverantorsorderId: this.leverantorsorderId
        };
    }
    leverantorsorderId: number;
    periodFrom: Date;
    periodTom: Date;
    leverantorsorderrader: number[];
    leverantorsordertyp: string;

    static readonly $groupKey = "leverantorsorder";
    static readonly $type = "CopyLeverantorsorderCommand";

    constructor(init: (instance: CopyLeverantorsorderCommand) => void) {
        super(CopyLeverantorsorderCommand.$type, CopyLeverantorsorderCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
